<template>
  <div>
    <div
      class="py-5 flex flex-col md:flex-row items-center gap-4 mb-4 justify-between w-full"
    >
      <div class="flex flex-col md:flex-row items-center gap-4 w-full md:w-auto">
        <form @submit.prevent="submitSearch()" class="w-full md:w-auto">
          <vs-input
            icon-no-border
            placeholder="Search"
            v-model="searchQuery"
            class="input-square-full w-full"
            icon="icon-search"
            icon-pack="feather"
          />
        </form>
        <div class="w-full md:w-auto md:flex-grow site-select-wrapper">
          <v-select
            placeholder="Select site"
            class="w-full"
            v-model="selectedSite"
            append-to-body
            :options="siteOptionLists"
            label="name"
            @input="onSiteChange"
          />
        </div>
      </div>
      <div class="w-full md:w-auto">
        <vs-button
          class="md:w-auto"
          @click="$router.push('/org_management/add_area')"
          color="#009FB2"
          >Add Area</vs-button
        >
      </div>
    </div>

    <vs-table stripe :data="lists">
      <template slot="thead">
        <vs-th @click="toggleSort('id')" class="cursor-pointer">
          <div class="flex items-center justify-center">
            <span>No</span>
          </div>
        </vs-th>
        <vs-th @click="toggleSort('name')" class="text-left cursor-pointer">
          <div class="flex items-center">
            <span>Area Name</span>
            <div
              class="ml-4 flex flex-col sort-icon-group"
              @click.stop="toggleSort('name')"
              style="cursor: pointer"
            >
              <font-awesome-icon
                :icon="['fas', 'caret-up']"
                :class="getSortClass('name', 'asc')"
              />
              <font-awesome-icon
                :icon="['fas', 'caret-down']"
                :class="getSortClass('name', 'desc')"
              />
            </div>
          </div>
        </vs-th>
        <vs-th @click="toggleSort('siteName')" class="text-left cursor-pointer">
          <div class="flex items-center">
            <span>Site Name</span>
            <div
              class="ml-4 flex flex-col sort-icon-group"
              @click.stop="toggleSort('siteName')"
              style="cursor: pointer"
            >
              <font-awesome-icon
                :icon="['fas', 'caret-up']"
                :class="getSortClass('siteName', 'asc')"
              />
              <font-awesome-icon
                :icon="['fas', 'caret-down']"
                :class="getSortClass('siteName', 'desc')"
              />
            </div>
          </div>
        </vs-th>
        <vs-th
          @click="toggleSort('countCamera')"
          class="text-center cursor-pointer"
        >
          <div class="flex items-center justify-center">
            <span>Cameras</span>
            <div
              class="ml-4 flex flex-col sort-icon-group"
              @click.stop="toggleSort('countCamera')"
              style="cursor: pointer"
            >
              <font-awesome-icon
                :icon="['fas', 'caret-up']"
                :class="getSortClass('countCamera', 'asc')"
              />
              <font-awesome-icon
                :icon="['fas', 'caret-down']"
                :class="getSortClass('countCamera', 'desc')"
              />
            </div>
          </div>
        </vs-th>
        <vs-th class="text-center">Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr class="pln-color" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="indextr">
            {{ (currentPage - 1) * itemsPerPage + indextr + 1 }}
          </vs-td>

          <vs-td class="text-left" :data="tr.name">
            {{ tr.name }}
          </vs-td>

          <vs-td class="text-left" :data="tr.siteName">
            {{ tr.siteName }}
          </vs-td>

          <vs-td class="text-center" :data="tr.countCamera">
            {{ tr.countCamera }}
          </vs-td>

          <vs-td class="text-center">
            <div class="flex justify-center gap-mini">
              <vs-tooltip text="Edit">
                <router-link :to="`/org_management/update_area/${tr.id}`">
                  <feather-icon icon="EditIcon" size="20" />
                </router-link>
              </vs-tooltip>
              <vs-tooltip text="Delete">
                <a href="" @click.prevent="conformDelete(tr.id)">
                  <feather-icon icon="TrashIcon" size="20" />
                </a>
              </vs-tooltip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <!-- Pagination -->
    <div class="pagination-container">
      <div class="pagination-left">
        <span class="mr-2 whitespace-nowrap">Show data</span>
        <vs-select
          class="items-per-page"
          v-model="itemsPerPage"
          @input="updateItemsPerPage"
        >
          <vs-select-item
            v-for="(option, index) in pageOptions"
            :key="index"
            :value="option.value"
            :text="option.text"
          />
        </vs-select>
      </div>
      <div class="pagination-right">
        <CustomPagination
          :current-page.sync="currentPage"
          :total-pages="totalPages"
          :total-data="totalData"
          @update:currentPage="getAreaLists"
        />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import CustomPagination from "@/components/CustomPagination.vue";
import vSelect from "vue-select";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCaretUp, faCaretDown);

export default {
  components: {
    CustomPagination,
    vSelect,
    "font-awesome-icon": FontAwesomeIcon,
  },
  data() {
    return {
      selectedId: "",
      selectedSite: null,
      siteOptionLists: [],
      searchQuery: "",
      lists: [],
      itemsPerPage: 10,
      currentPage: 1,
      totalData: 0,
      totalPages: 0,
      sortField: "",
      sortOrder: "asc",
      pageOptions: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      // lists: [
      //   {
      //       "areaId" : 1,
      //       "areaName" : "GATE PARKING",
      //       "siteId": 3,
      //       "cameras": 21,
      //       "status": 1,
      //       "sites":{
      //           "siteId": 1,
      //           "siteName": "POS LOGISTIC"
      //       }
      //   },
      //   {
      //       "areaId" : 2,
      //       "areaName" : "LOBBY",
      //       "siteId": 3,
      //       "cameras": 10,
      //       "status": 1,
      //       "sites":{
      //           "siteId": 1,
      //           "siteName": "POS LOGISTIC"
      //       }
      //   }
      // ],
    };
  },
  mounted() {
    this.getSiteOptions();
    this.getAreaLists();
  },
  methods: {
    //Update item pe pages (handling for change limit of page)
    updateItemsPerPage() {
      this.currentPage = 1;
      this.getAreaLists();
    },
    getSiteOptions() {
      api
        .siteOption({})
        .then((result) => result.data)
        .then((data) => {
          console.log("✅ [getSiteOptions] Response:", data);
          if (data.status && data.data) {
            this.siteOptionLists = data.data;
          }
        })
        .catch((e) => {
          console.error("❌ [getSiteOptions] Error:", e);
        });
    },
    onSiteChange() {
      console.log("🔄 [onSiteChange] Selected site:", this.selectedSite);
      this.currentPage = 1;
      this.getAreaLists();
    },
    submitSearch() {
      this.currentPage = 1;
      this.getAreaLists();
    },
    getAreaLists() {
      this.$vs.loading();
      const params = {
        search: this.searchQuery,
        page: this.currentPage,
        limit: this.itemsPerPage,
      };

      if (this.selectedSite && this.selectedSite.id) {
        params.siteId = this.selectedSite.id;
      }

      if (this.sortField) {
        params.sort = `${this.sortField} ${this.sortOrder}`;
      }

      console.log("📦 [getAreaLists] API Params:", params);

      api
        .areas(params)
        .then((result) => result.data)
        .then((data) => {
          console.log("✅ [getAreaLists] Response:", data);
          if (data.status) {
            this.lists = data.data;
            this.totalData = data.totalData;
            this.totalPages = data.maxPage;
            this.$store.dispatch("updateAreaLists", data.data);
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.error("❌ [getAreaLists] Error:", e);
          this.$vs.loading.close();
        });
    },
    toggleSort(field) {
      console.log("🔽 [toggleSort] Clicked field:", field);

      if (this.sortField === field) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }

      console.log("🔄 [toggleSort] New sortField:", this.sortField);
      console.log("🔄 [toggleSort] New sortOrder:", this.sortOrder);

      this.getAreaLists();
    },
    getSortClass(field, direction) {
      const isActive = this.sortField === field && this.sortOrder === direction;
      return {
        "sort-icon": true,
        active: isActive,
      };
    },
    conformDelete(id) {
      this.selectedId = id;
      this.$vs.dialog({
        color: "danger",
        title: `Confirm Delete`,
        text: "Are you sure will delete this data?.",
        accept: this.doDelete,
      });
    },
    doDelete() {
      this.$vs.loading();
      api
        .deleteArea({ id: this.selectedId })
        .then((result) => result.data)
        .then((data) => {
          console.log(data);
          this.selectedId = "";

          this.$vs.notify({
            title: "Success",
            text: "Delete data success",
            color: "success",
            position: "top-right",
          });

          this.$vs.loading.close();
        })
        .finally(() => {
          this.getAreaLists();
        })
        .catch((e) => {
          console.log(e);
          this.selectedId = "";

          this.$vs.notify({
            title: "Failed",
            text: "Delete data failed",
            color: "danger",
            position: "top-right",
          });

          this.$vs.loading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.site-select-wrapper {
  width: 100%;
}
@media (min-width: 768px) {
  .site-select-wrapper {
    min-width: 350px;
    width: auto;
  }
}
.icon {
  margin: 0 5px;
}
.w-200 {
  width: 200px;
}
::v-deep .vs-con-select {
  width: 100%;
}
::v-deep .vs-select__selections {
  overflow: visible !important;
  white-space: normal;
}
.text-center:deep(.vs-table-text) {
  justify-content: center;
}
.text-right:deep(.vs-table-text) {
  justify-content: flex-end;
}
.cursor-pointer {
  cursor: pointer;
}
.sort-icon-group {
  line-height: 0.7;
}
.sort-icon {
  color: white;
  font-size: 12px;
  transition: opacity 0.2s ease;
}
.sort-icon.active {
  opacity: 1;
  color: #009fb2;
}
.items-per-page {
  width: 80px;
}
::v-deep .items-per-page .vs-select {
  width: 100%;
}
.pagination-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  gap: 1rem;
  width: 100%;
}
@media (min-width: 768px) {
  .pagination-container {
    flex-direction: row;
    gap: 0;
  }
}
.pagination-left {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
@media (min-width: 768px) {
  .pagination-left {
    justify-content: flex-start;
    width: auto;
  }
}
.pagination-right {
  width: 100%;
  display: flex;
  justify-content: center;
  overflow-x: auto;
}
@media (min-width: 768px) {
  .pagination-right {
    width: auto;
    justify-content: flex-end;
  }
}
</style>
